import React, { useEffect, useState } from "react";
import { Col, Row, Button, Container } from "react-bootstrap";
import { images } from "../../constants";
import BackArrow from "../backArrow";
import ShopAdds from "../shopAds/ShopAdds";
import "./FoodReport.css";
import Suggestion from "../../pages/suggestion";
import { getAsset } from "../../helpers/helper";
import Reportmodal from "../Reportmodal/index";
import { useParams } from "react-router-dom";
import { useGetServiceDetailQuery } from "../../features/service/serviceApiSlice";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";

const ReportSection = ({ title, suggestdata, id }) => {
  const [suggest, setSuggest] = useState(false);
  const [hide, setHide] = useState(true);
  const [getService, setGetService] = useState();
  const ReadClick = () => {
    setSuggest(true);
    setHide(false);
  };

  const [singleid, setSingleid] = useState();
  const [openBox, setOpenBox] = useState(1);

  const { data: serviceRes } = useGetServiceDetailQuery(id, { skip: !id });

  useEffect(() => {
    if (serviceRes?.success) {
      setGetService(serviceRes?.data?.Service);
    }
  }, [serviceRes]);

  return (
    <>
      <div className="container-fluid">
        <Container className="Container_w">
          <div className="screenHeight">
            <Row className="justify-content-center border row_div border_3 ">
              <Col md={10} lg={10} className="col_adjust col_border webkit">
                <div>
                  <BackArrow />
                </div>
                <div className="padding_adds">
                  <ShopAdds />
                </div>
              </Col>
              {suggest === true && (
                <Col lg={12} className="mx-auto">
                  <Suggestion
                    setSuggest={setSuggest}
                    setHide={setHide}
                    suggestsingleid={singleid}
                    shopid={id}
                    getService={getService}
                  />
                </Col>
              )}

              {openBox === 2 && (
                <Reportmodal
                  reportM={singleid}
                  shopid={id}
                  setOpenBox={setOpenBox}
                  setHide={setHide}
                />
              )}
            </Row>
            {hide === true && (
              <Row className="justify-content-center border row_div screen_height noscroll mt-2">
                {title && <h4 className="text-left">{title}</h4>}
                {suggestdata?.map((items, index) => (
                  <Col
                    key={index}
                    md={10}
                    lg={10}
                    className={`col_border border_3 sec_col webkit ${
                      index % 2 === 1 ? "odd-background" : ""
                    }`}
                  >
                    <Col md={2} lg={1}>
                      <img
                        src={
                          items?.imageUrl && items.imageUrl.length > 0 ? (getAsset(items?.imageUrl[0]) || getAsset(items?.imageUrl)) : noImagePlaceholder
                        }
                        alt="image"
                        className="img_s"
                        crossOrigin="anonymous"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImagePlaceholder;
                        }}
                      />
                    </Col>
                    <Col md={8} lg={9} className="mt-3">
                      <b>{items?.fullname}</b> <br></br>
                      {items?.role || items?.reportType}
                      <p className="title breakword">
                        {(items?.message || items?.description).length > 100
                          ? (items?.message || items?.description).slice(
                              0,
                              100
                            ) + "..."
                          : items?.message || items?.description}
                      </p>
                    </Col>

                    <Col md={2} lg={2} className="button_padding ">
                      <button
                        type="button"
                        className="btn btn-primary read_btn"
                        onClick={
                          items?.reportType?.length > 0
                            ? () => {
                                setHide(false);
                                setOpenBox(2);
                                setSingleid(items?._id);
                              }
                            : () => {
                                ReadClick();
                                setSingleid(items?._id);
                              }
                        }
                      >
                        Read
                      </button>
                    </Col>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </Container>
      </div>
    </>
  );
};

export default ReportSection;
